module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-1-cffe9a3e5682d9b736e60918e3e2dc1f.svg";